import { render, staticRenderFns } from "./DefaultTemplate.vue?vue&type=template&id=60f4e545&scoped=true&"
import script from "./DefaultTemplate.vue?vue&type=script&lang=js&"
export * from "./DefaultTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DefaultTemplate.vue?vue&type=style&index=0&id=60f4e545&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f4e545",
  null
  
)

export default component.exports